// The link resolver's whole vocabulary. Three states, nothing else to branch on.
export const LINK_STATE_READY = "ready";
export const LINK_STATE_LOGIN_REQUIRED = "login_required";

export const LOGIN_LINK_PARAM = "login_link";

export const APPROVAL_STATUS_APPROVED = "approved";
export const APPROVAL_STATUS_REJECTED = "rejected";

// Same ceiling the API validates the comment against.
export const COMMENT_MAX_LENGTH = 180;
